/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Continue_PlusInputs */

const en_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const ar_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const de_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const es_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const fr_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const it_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const ja_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const ko_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const pt_br_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const ru_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const th_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const tr_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Membership`)
};

const zh_cn_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即续费`)
};

const zh_tw_btn_continue_plus = /** @type {(inputs: Btn_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即续费`)
};

/**
* | output |
* | --- |
* | "Extend Membership" |
*
* @param {Btn_Continue_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_continue_plus = /** @type {((inputs?: Btn_Continue_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Continue_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_continue_plus(inputs)
	if (locale === "ar") return ar_btn_continue_plus(inputs)
	if (locale === "de") return de_btn_continue_plus(inputs)
	if (locale === "es") return es_btn_continue_plus(inputs)
	if (locale === "fr") return fr_btn_continue_plus(inputs)
	if (locale === "it") return it_btn_continue_plus(inputs)
	if (locale === "ja") return ja_btn_continue_plus(inputs)
	if (locale === "ko") return ko_btn_continue_plus(inputs)
	if (locale === "pt_br") return pt_br_btn_continue_plus(inputs)
	if (locale === "ru") return ru_btn_continue_plus(inputs)
	if (locale === "th") return th_btn_continue_plus(inputs)
	if (locale === "tr") return tr_btn_continue_plus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_continue_plus(inputs)
	return zh_tw_btn_continue_plus(inputs)
});